<template>
    <Modal :show="show" :title="modalTitle" size="small" @onModalClose="handleClose">
        <div v-if="shift" class="shift-comments-modal">
            <div class="shift-info">
                <span class="info-item">
                    <span class="label">Fahrer:</span>
                    <span class="value">{{ driverName }}</span>
                </span>
                <span class="info-item">
                    <span class="label">Schicht:</span>
                    <span class="value">{{ shift.sequenceNumber || 'N/A' }}</span>
                </span>
                <span class="info-item">
                    <span class="label">Kennzeichen:</span>
                    <span class="value">{{ shift.licenseNumber || 'N/A' }}</span>
                </span>
                <span v-if="concession" class="info-item">
                    <span class="label">Konzession:</span>
                    <span class="value">{{ concession }}</span>
                </span>
            </div>
            <Comment
                :key="commentKey"
                resource-type="shifts"
                :resource-uuid="shiftUuid"
                :margin-top="1"
            />
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/widgets/Modal.vue';
import Comment from '@/components/widgets/Comment.vue';

export default {
    name: 'ShiftCommentsModal',
    components: {
        Modal,
        Comment,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        shift: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            commentKey: 0,
        };
    },
    computed: {
        shiftUuid() {
            return this.shift?.uuid || this.shift?._id || '';
        },
        driverName() {
            if (!this.shift) return 'N/A';
            if (typeof this.shift.driver === 'string') {
                return this.shift.driver;
            }
            return this.shift.driver?.name || 'N/A';
        },
        concession() {
            if (!this.shift) return null;
            if (this.shift.concession !== undefined && this.shift.concession !== null) {
                return String(this.shift.concession);
            }
            return null;
        },
        modalTitle() {
            if (!this.shift) return 'Kommentare';
            const driver = this.driverName;
            const sequenceNumber = this.shift.sequenceNumber || 'N/A';
            return `Kommentare - Schicht ${sequenceNumber} (${driver})`;
        },
    },
    watch: {
        show(newVal) {
            if (!newVal) {
                this.commentKey += 1;
            }
        },
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.shift-comments-modal {
    .shift-info {
        background-color: var(--color-bg);
        border: 0.5px solid var(--color-border);
        border-radius: 6px;
        padding: 8px 12px;
        margin-bottom: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 12px 16px;
        font-size: 0.75rem;

        .info-item {
            display: inline-flex;
            align-items: center;
            gap: 4px;

            .label {
                font-weight: 600;
                color: var(--color-text-secondary);
            }

            .value {
                color: var(--color-text-black);
            }
        }
    }
}
</style>
